<template>
  <div id="app">
    <LoadingBar />
    <Navbar />
    <router-view v-slot="{ Component }">
      <Transition name="page" mode="out-in">
        <component :is="Component" />
      </Transition>
    </router-view>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/fragments/NavbarSide.vue';
import Footer from '@/components/fragments/FooterSide.vue';
import LoadingBar from '@/components/fragments/LoadingBar.vue';

export default {
  name: 'App',
  components: { Navbar, Footer, LoadingBar }
};
</script>

<style>
*, *::before, *::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background-color: #090909;
}

#app {
  font-family: 'Inter', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #090909;
  color: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
